module.exports = __webpack_public_path__ + "static/nossos-certificados-31d117754b41a985a5f22352b5cc088b.svg";